import { render, staticRenderFns } from "./OpportunitiesOverview.vue?vue&type=template&id=7fe2f027&scoped=true&"
import script from "./OpportunitiesOverview.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OpportunitiesOverview.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OpportunitiesOverview.vue?vue&type=style&index=0&id=7fe2f027&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe2f027",
  null
  
)

export default component.exports